import React, { ChangeEvent, FC } from "react";
import styles from "./SearchBar.module.css";

interface SearchBarProps {
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
    id?: string;
}

const SearchBar: FC<SearchBarProps> = ({
    value,
    onChange,
    placeholder = "Search...",
    id = "search-bar",
}) => {
    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        onChange(event.target.value);
    };

    const clearInput = () => {
        onChange("");
    };

    return (
        <div className={styles.container}>
            <input
                id={id}
                className={styles.searchInput}
                type="text"
                value={value}
                onChange={handleChange}
                placeholder={placeholder}
            />
            {value && (
                <button
                    type="button"
                    className={styles.clearButton}
                    onClick={clearInput}
                    aria-label="Clear search"
                >
                    &#x2715;
                </button>
            )}
        </div>
    );
};

export default SearchBar;
